import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import MuiButton from '@mui/material/Button';

interface StyledProps {
  fontColor?: string;
}

export const StCountTrailWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.neutral2.main,
}));

export const StCountTrailContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  backgroundSize: 'cover',
  paddingBlock: '60px',
  paddingLeft: '5.5rem',
  paddingRight: '5.5rem',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left',
    width: '100%',
    paddingInline: '2rem !important',
  },
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
  },
  [theme.breakpoints.up('xl')]: {
    width: '1366px',
    marginInline: 'auto',
  },
  [theme.breakpoints.down(1150)]: {
    paddingLeft: '4rem',
    paddingRight: '3rem',
  },
}));

export const StRichTextGridItem = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fontColor',
})<StyledProps>(({ fontColor, theme }) => ({
  '& .title': {
    fontSize: '24px',
    color: fontColor || theme.palette.themeColor.main,
    fontWeight: '600',
  },
  '& .description': {
    fontSize: '16px',
    color: '#333333',
    fontWeight: '400',
  },
}));

export const ViewTrialsButton = styled(MuiButton)(({ theme, variant }) => ({
  fontSize: '1rem',
  fontStyle: 'normal',
  fontFamily: `${theme?.palette?.primaryFontSemiBoldType || 'Proxima Nova SemiBold'}`,
  textTransform: 'none',
  borderRadius: variant === 'contained' || variant === 'outlined' ? '50px' : '0px',
  width: '112px',
  filter:
    variant === 'contained'
      ? 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.50))'
      : 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.08))',
  border:
    variant === 'contained'
      ? `1px solid ${theme.palette.primary.main}`
      : variant === 'outlined'
      ? `1px solid ${theme.palette.neutral4.main}`
      : 'none',
  background:
    variant === 'contained'
      ? theme.palette.primary.main
      : variant === 'outlined'
      ? theme.palette.secondary.main
      : 'none',
  '&:hover': {
    background:
      variant === 'contained'
        ? theme.palette.primary.dark
        : variant === 'outlined'
        ? theme.palette.secondary.dark
        : 'none',
    borderBottom:
      variant === 'contained' || variant === 'outlined'
        ? `1px solid ${theme.palette.primary.main}`
        : '1px dashed',
    color: variant === 'contained' ? theme.palette.white.main : theme.palette.primary.main,
  },
}));

export const StCountTrailCircle = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '155px',
  height: '155px',
  borderRadius: '50%',
  border: `6px solid ${theme.palette.neutral0.main}`,
  opacity: 1,
  background: `linear-gradient(1.33deg, ${theme.palette.themeColor.main} -2.85%, ${theme.palette.themeColorSecondary.main} 144.31%)`,
}));

export const StCountTrailCircleLabel = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  color: theme.palette.neutral0.main,
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: '700',
}));
